// Đường dẫn trang → module khoá theo gói (sếp Phú 15/09/2026 — "mua gói nào dùng gói đó").
//
// Derive từ chính NAV_GROUPS (cùng cách routePermission.js) ⇒ thêm mục menu vào nhóm CRM là tự khoá theo
// CRM, không có bản đồ tay nào để trôi. Mã module khớp api/src/services/moduleAccessService.MODULES.
//
// Chỉ lo phần NHÌN (thay nội dung trang bằng màn bảng giá). Chốt thật ở BE: orgTenantGate trả 402 cho mọi
// lệnh GHI vào module chưa mua, kể cả từ app điện thoại.

/** Nhóm menu (NAV_GROUPS.key) → module. Nhóm không có ở đây thì không bao giờ khoá. */
export const GROUP_MODULE = {
  crm: 'crm',
  employees: 'hr',
  projects: 'tasks',
  tasks: 'tasks',
  approvals: 'approvals',
  support: 'support',
  marketing: 'marketing',
  recruitment: 'recruitment',
  automation: 'automation',
};

// Đường không có mục menu nhưng vẫn thuộc (hoặc cố ý KHÔNG thuộc) một module.
//   /payroll                — menu Lương đang ẩn, trang vẫn route được (xem routePermission EXTRA_GATES)
//   /support                — đường cũ của ticket, còn link đã gửi
//   /recruitment/pipelines  — alias Thư viện Pipeline dùng chung CRM + tuyển dụng ⇒ KHÔNG khoá
const EXTRA = [
  ['/payroll', 'hr'],
  ['/support', 'support'],
  ['/recruitment/pipelines', null],
];

// Nhóm con (item.group) LUÔN MỞ dù module chủ đang khoá — sếp Phú 15/09/2026, ca quoctuedu mua CRM Only.
//   employees › «Nhân sự» = Nhân viên, Lời mời nhân viên, Sự kiện, Team / Phòng ban, Sơ đồ tổ chức. Đây là chỗ
//   DUY NHẤT tạo + khoá tài khoản người dùng của workspace ⇒ gói nào cũng phải dùng được, không thì khách mua
//   CRM Only không mời nổi ai. Hợp đồng, Chấm công, Nghỉ phép, Tài sản… vẫn khoá theo gói.
//   BE khớp sẵn: các màn này GHI qua /users, /teams, /org-chart — không nằm trong WRITE_PREFIXES của
//   moduleAccessService (test ghim ở moduleAccessByPlan.test.js).
export const ALWAYS_OPEN_SUBGROUPS = {
  employees: ['Nhân sự'],
};

const clean = (p) => String(p || '').split('?')[0].replace(/\/+$/, '');

/** [[prefix, module|null]] sắp dài trước để tiền tố cụ thể thắng. */
export function buildModuleRouteMap(navGroups) {
  const out = [];
  const push = (path, code) => { const p = clean(path); if (p) out.push([p, code]); };
  for (const g of navGroups || []) {
    const code = GROUP_MODULE[g.key] || null;
    const open = ALWAYS_OPEN_SUBGROUPS[g.key] || [];
    // Mục menu đẩy TRƯỚC basePath của nhóm: cùng một đường thì mục thắng (sort ổn định + find lấy phần tử đầu).
    // '/employees' vừa là basePath nhóm Nhân sự (khoá) vừa là mục «Nhân viên» (luôn mở) ⇒ trang chi tiết
    // /employees/:id cũng mở theo.
    for (const it of g.items || []) push(it.path, open.includes(it.group) ? null : code);
    push(g.basePath, code);
    push(g.path, code);
  }
  for (const [p, code] of EXTRA) push(p, code);
  return out.sort((a, b) => b[0].length - a[0].length);
}

/**
 * Module đang khoá ứng với trang này, `null` = hiện trang bình thường.
 * `access` undefined (bản BE cũ / lỗi) hoặc `enforced=false` (workspace đời cũ) ⇒ không khoá gì.
 */
export function lockedModuleForPath(pathname, routeMap, access) {
  if (!access?.enforced || !access.locked?.length) return null;
  const path = clean(pathname) || '/';
  const hit = routeMap.find(([p]) => path === p || path.startsWith(`${p}/`));
  const code = hit?.[1];
  return code && access.locked.includes(code) ? code : null;
}
